<template>
  <div class="legend-box" :style="getCustomStyle(startGameConfig)">
    <div
      class="legend-title"
      v-if="typeof startGameConfig.title != 'undefined' && startGameConfig.title != null"
      :style="getCustomStyle(startGameConfig.title)"
    >
      {{ startGameConfig.title.text }}
    </div>
    <div class="legend-scale">
      <div
        class="image-container"
        v-if="startGameConfig.body"
        :style="getImageStyle(startGameConfig.body && startGameConfig.body.imageData)"
      ></div>
      <!-- <ul class="legend-labels">
        <li><span style="background:#F1EEF6;"></span>0 - 20%</li>
        <li><span style="background:#BDC9E1;"></span>40%</li>
        <li><span style="background:#74A9CF;"></span>60%</li>
        <li><span style="background:#2B8CBE;"></span>80%</li>
        <li><span style="background:#045A8D;"></span>100%</li>
      </ul> -->
    </div>
    <div
      class="legend-source"
      v-if="typeof startGameConfig.source !== 'undefined' && startGameConfig.source != null"
      :style="getCustomStyle(startGameConfig.source)"
    >
      <span v-if="!checkKatexMarker(startGameConfig.source.text)" v-html="startGameConfig.source.text"></span>
      <span v-if="checkKatexMarker(startGameConfig.source.text)">
        <ps-text :text-value="`${startGameConfig.source.text}`"></ps-text>
      </span>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
import defaultMixins from '../../mixins/defaultMixin';
import PsText from '../TrInput/PsText';

export default {
  name: 'mp-legend',
  mixins: [defaultMixins],
  components: { PsText },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    checkKatexMarker(item) {
      let flag = item.search('_#');
      if (flag == -1) {
        return false;
      }
      return true;
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge({}, this.getCustomStyle(imageData), {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.legend-box {
  box-shadow: 4px 4px 6px #aaa;
  border: 1px solid #aaa;
  padding: 8px;
}
.legend-box .legend-title {
  text-align: left;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 90%;
}
.legend-box .legend-scale ul {
  margin: 0;
  padding: 0;
  float: left;
  list-style: none;
}
.legend-box .legend-scale ul li {
  display: block;
  float: left;
  width: 50px;
  margin-bottom: 6px;
  text-align: center;
  font-size: 80%;
  list-style: none;
}
.legend-box ul.legend-labels li span {
  display: block;
  float: left;
  height: 15px;
  width: 50px;
}
.legend-box .legend-source {
  font-size: 70%;
  color: #999;
  clear: both;
}
.legend-box a {
  color: #777;
}
</style>
